import { IIcon } from '@models/IIcon';
import classNames from 'classnames';
import IcoMoon from 'react-icomoon';
import iconSet from './selection.json';

const Icon = ({
  ariaHidden,
  className,
  color,
  colorClassName = 'text-black-100',
  name = 'check',
  size = '1.5rem',
  width,
  height,
}: IIcon) => (
  <IcoMoon
    icon={name}
    size={width && height ? '' : size}
    width={width}
    height={height}
    color={color}
    iconSet={iconSet}
    className={classNames(className, colorClassName, name)}
    {...(ariaHidden ? { 'aria-hidden': true } : {})}
  />
);

export default Icon;
